import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'lognai-sidebar-collapsed';

function getStored(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

// Module-level singleton — shared across all hook instances in the same tab.
let collapsed: boolean = getStored();
const listeners = new Set<() => void>();

function apply(next: boolean) {
  document.documentElement.setAttribute('data-sidebar-collapsed', String(next));
  try {
    window.localStorage.setItem(STORAGE_KEY, String(next));
  } catch {}
}

// Apply on module load so the attribute is set before first render.
apply(collapsed);

function subscribe(callback: () => void) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

function getSnapshot() {
  return collapsed;
}

export function setCollapsed(next: boolean) {
  collapsed = next;
  apply(next);
  listeners.forEach((l) => l());
}

export function toggleCollapsed() {
  setCollapsed(!collapsed);
}

export function useSidebarCollapsed() {
  const value = useSyncExternalStore(subscribe, getSnapshot);
  return { collapsed: value, setCollapsed, toggleCollapsed };
}
